import { Database, Globe, Server, Users } from "lucide-react";

const ProfileTab = ({ profileData }) => {

    return (<>    
        <div className="space-y-5 animate-in fade-in duration-500">
            <h3 className="text-xl font-bold text-slate-900 mb-6">Compliance Profile</h3>
            <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="flex items-start gap-4">
                        <div className="p-3 bg-indigo-50 text-indigo-600 rounded-xl"><Server size={24} /></div>
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Industry</p>
                            <p className="text-lg font-bold text-slate-800">{profileData.industry}</p>
                        </div>
                    </div>
                    <div className="flex items-start gap-4">
                        <div className="p-3 bg-blue-50 text-blue-600 rounded-xl"><Globe size={24} /></div>
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Regions</p>
                            <p className="text-lg font-bold text-slate-800">{profileData.regions}</p>
                        </div>
                    </div>
                    <div className="flex items-start gap-4">
                        <div className="p-3 bg-emerald-50 text-emerald-600 rounded-xl"><Database size={24} /></div>
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Data Sensitivity</p>
                            <p className="text-lg font-bold text-slate-800">{profileData.dataSensitivity}</p>
                        </div>
                    </div>
                    <div className="flex items-start gap-4">
                        <div className="p-3 bg-rose-50 text-rose-600 rounded-xl"><Server size={24} /></div>
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Infrastructure</p>
                            <p className="text-lg font-bold text-slate-800">{profileData.infrastructure}</p>
                        </div>
                    </div>
                    <div className="flex items-start gap-4">
                        <div className="p-3 bg-amber-50 text-amber-600 rounded-xl"><Users size={24} /></div>
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Company Size</p>
                            <p className="text-lg font-bold text-slate-800">{profileData.companySize}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
};

export default ProfileTab;